import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

interface ErrorType {
  data?: { message?: string };
  message?: string;
}

export const errorHelper = (error: unknown): string => {
  let errorMessage = 'Failed to fetch data';
  if (error && typeof error === 'object') {
    const err = error as ErrorType;
    if (err.data && err.data.message) {
      errorMessage = err.data.message;
    } else if (err.message) {
      errorMessage = err.message;
    }
  }
  return errorMessage;
};

export const promiseAllErrorsToString = (
  res: (
    | {
        data: any;
        error?: undefined;
      }
    | {
        data?: undefined;
        error: FetchBaseQueryError | SerializedError;
      }
  )[]
): string | null => {
  const errors = res
    .filter(res => res?.error)
    .map(res => (res.error as any)?.data?.message || 'Unknown error');

  if (errors.length > 0) {
    const errorMessage = errors.join(' | ');

    return errorMessage;
  }

  return null;
};
